<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pt-0">
        <gg-card-title class="pt-0">
          {{ $route.meta.pageTitle }}
        </gg-card-title>
        <affiliates-navigation />
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AffiliatesNavigation from '@/components/Affiliates/AffiliatesNavigation'

export default {
  name: 'AffiliatesView',
  components: {
    AffiliatesNavigation,
  },

}
</script>
